import { EventBlogPanel } from "../../../components/admin/event-hub/EventBlogPanel";

export function AdminEventBlogPage() {
  return <EventBlogPanel />;
}
